import * as React from "react";
function SvgGenderFemale(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 9A5 5 0 117 9a5 5 0 0110 0zm-4 6.93A7.002 7.002 0 0012 2a7 7 0 00-1 13.93v1.514H8v2h3V22h2v-2.556h3v-2h-3V15.93z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgGenderFemale);
export default ForwardRef;
